import React, { Component } from 'react';
import {CKEditor} from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import PropTypes from 'prop-types';

import './Editor.less';

const editorConfiguration = {
    toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', 'undo', 'redo'],
    link: {
        decorators: {
            addTargetToExternalLinks: {
                mode: 'automatic',
                callback: url => !/(file|ftps?|mailto|javascript):/.test(url),
                attributes: {
                    target: '_blank',
                    rel: 'noopener noreferrer'
                }
            }
        }
    }
};

export default class Editor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: undefined,
            editor: undefined,
        }
    }

    onInit = (editor) => {
        this.props.existingContent && editor.setData(this.props.existingContent);
        this.setState({editor});
    };

    onChange = (e, editor) => {
        let data = editor.getData();

        data = this.sanitizeEditorData(data);

        this.setState({data});

        this.props.onChange(data);
    };

    /**
     * Prepend http to links that do not have http.
     *
     * @param data string
     * @returns {*}
     */
    sanitizeEditorData = (data) => {
        // Find href strings
        const links = data.match(/href="(.*?)"/g);

        if (links === null) return data;

        for (let link of links) {
            // test if url is relative url
            let isStringRelativeUrl = !/(https?|file|ftps?|mailto|javascript):/.test(link);

            if (isStringRelativeUrl) {
                // Prepend http
                let stringArray = link.split(/"/);
                stringArray[1] = 'http://' + stringArray[1];
                let linkWithHttp = stringArray.join('"');

                // Replace original data
                data = data.replace(link, linkWithHttp);
            }
        }
        return data;
    };

    render() {
        const config = {
            ...editorConfiguration,
            placeholder: this.props.placeholder,
        }

        return (
            <>
                <CKEditor
                    editor={ClassicEditor}
                    config={config}
                    onReady={this.onInit}
                    onChange={this.onChange}
                />
            </>
        )
    }
}

Editor.propTypes = {
    existingContent: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
};

Editor.defaultProps = {
    placeholder: '',
}
